import React from "react";
import HeroPestImage from '../../img/form index.png'
import { Quote, Star, User } from "lucide-react";
import HomeServices from "./HomeServices";
import HomeAboutUs from "./HomeAboutUs";
import CTA from "../Cta";
import Marque from "../Marque";
import WhyChooseUs from "./WhyChooseUs";
import BestServices from "./BestService";
import ConnectWithUsForm from "../ConnectUs";
import OurWorks from "../OurWorks";

const Home = () => {
    return (
        <>
            <main className="hob-main-home-section">
                <section className="hob-main-home-hero">
                    <div className="hob-main-home-left">
                        <h1 className="hob-main-home-highlight-text">Spiracle Pest Worlds</h1>
                        <h2 className="hob-main-home-heading">Professional & Eco-friendly Pest Control</h2>
                        <p className="hob-main-home-paragraph">
                            Spiracle Pest Management Services delivers professional, eco-friendly and cost-effective Integrated Pest Management solutions for residential & commercial premises across Mumbai and its suburbs.
                        </p>
                        <div className="hob-main-home-cta">
                            <button
                                className="hob-main-home-cta-primary"
                                onClick={() => (window.location.href = "tel:8530352444")}
                                style={{ cursor: "pointer" }}
                            >
                                Book a Service
                            </button>
                            <button
                                className="hob-main-home-cta-secondary"
                                onClick={() => {
                                    const el = document.getElementById("services-section-hob");
                                    if (el) {
                                        el.scrollIntoView({ behavior: "smooth" });
                                    }
                                }}
                                style={{ cursor: "pointer" }}
                            >
                                Explore Services
                            </button>
                        </div>
                    </div>
                    <div className="hob-main-home-right">
                        <div className="hob-main-right-testimonial">
                            <span className="hob-testimonial-icon"><Quote size={20} /></span>
                            <p className="hob-testimonial-text">
                                “Completely pest free home!”
                            </p>
                        </div>
                        <img
                            src={HeroPestImage}
                            alt="Professional pest control technician"
                            className="hob-main-home-image"
                        />
                        <div className="hob-main-right1-testimonial">
                            <span className="hob-testimonial-icon">
                                <User size={20} />
                            </span>
                            <p className="hob-testimonial-text">
                                Satish R.
                            </p>
                            <div className="hob-testimonial-stars">
                                <Star size={16} />
                                <Star size={16} />
                                <Star size={16} />
                                <Star size={16} />
                                <Star size={16} />
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Marque />
            <HomeAboutUs />
            <WhyChooseUs />
            <div id="services-section-hob">
                <HomeServices />
            </div>
            <BestServices />
            <CTA />
            <OurWorks />
            <ConnectWithUsForm />
        </>
    );
};

export default Home;
